import React from "react"
import Modal from '@material-ui/core/Modal';

import QR from "../qrcode/qrcode";

import closeIcon from "../../images/close.svg"
import { getQueryParamValueByName } from "../../utils/query_params.js"
import { getDevice } from "../../utils/getDevice.js"

import styles from "./qrcodeModal.module.scss"

import { PARTNER_CONFIG } from "../../constants.js"

const QRCodeModalContext = React.createContext({
  handleShow: (isPartner) => { },
  handleHide: () => { },
});

export const QRCodeModalProvider = ({ children, partnerKey }) => {
  const utmSource = getQueryParamValueByName("utm_source");
  const gclid = getQueryParamValueByName("gclid");
  const msclkid = getQueryParamValueByName("msclkid");
  const campaignCodeParam = getQueryParamValueByName("campaignCode");

  const config = PARTNER_CONFIG[partnerKey];
  const isPartner = !!config && config.branchPath.length > 0;

  const device = getDevice();

  const [open, setOpen] = React.useState(false);

  const bgColor = "#FFFFFF";

  let branchPath = `/sayiDSdmgfb`
  if (isPartner) {
    branchPath = config.branchPath
  }

  let campaignCode = ""
  if (!!campaignCodeParam && campaignCodeParam.length > 0) {
    campaignCode = campaignCodeParam
  } else if (isPartner) {
    campaignCode = config.campaignCode
  }

  const qrURL = React.useMemo(() => {
    let result = `${process.env.BRANCH_BASE_URL}${branchPath}`

    if (!!campaignCode && campaignCode.length > 0) {
      result = `${result}?campaignCode=${campaignCode}`
    }

    return result
  }, [branchPath, campaignCode])

  const handleShow = (isPartner) => {
    if ( device === "ios" || device === "android" ) {
      let url = `${process.env.BRANCH_BASE_URL}/nMP8uZKdffb`

      if (!!utmSource && utmSource.length > 0 && utmSource.toLowerCase() === "facebook") {
        url = `${process.env.BRANCH_BASE_URL}/ttd-facebook`
      } else if (!!gclid && gclid.length > 0) {
        url = `${process.env.BRANCH_BASE_URL}/ttd-google`
      } else if (!!msclkid && msclkid.length > 0) {
        url = `${process.env.BRANCH_BASE_URL}/lIqqiignPfb`
      }
  
      if (isPartner) {
        url = `${process.env.BRANCH_BASE_URL}${branchPath}`
      }

      if (!!campaignCode && campaignCode.length > 0) {
        url = `${url}/?campaignCode=${campaignCode}`
      }

      window.location.href = url
    } else {
      setOpen(true);
    }
  };

  const handleHide = () => (
    setOpen(false)
  );

  return (
    <QRCodeModalContext.Provider value={{ handleShow, handleHide }}>
      {children}
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={handleHide}
      >
        <div className={styles.paper}>
          <div className={styles.modalContainer}>
            <div className={styles.contentContainer}>
              <div className={styles.instructionsContainer}>
                <h3 className={styles.modalTitle}>Almost there!</h3>
                <p className={styles.modalCopy}>Our FREE card, in tandem with our app, helps kids make real-life tradeoffs between spending and saving. <strong>Scan this code with your phone’s camera to download Till.</strong></p>
              </div>
            </div>
            <div className={styles.contentContainer}>
              <div className={styles.qrCodeContainer}>
                <QR bgColor={bgColor} url={qrURL} size={160} height={160} width={160} />
                <p className={styles.subtitle}>Scan to download</p>
              </div>
            </div>
          </div>
          <button onClick={() => handleHide()} tabindex="0" className={styles.closeContainer}>
            <img className={styles.closeIcon} src={closeIcon} alt="close modal" />
          </button>
        </div>
      </Modal>
    </QRCodeModalContext.Provider>
  );
}

export const QRCodeModalConsumer = QRCodeModalContext.Consumer;
